<template>
    <v-card elevation="2" :loading="loading" :disabled="loading">
        <v-card-text class="pa-0">
            <v-simple-table>
                <thead>
                    <tr>
                        <th>
                            {{ title }}
                        </th>
                        <th>
                            สถานะการตอบแบบประเมิน
                        </th>
                        <th v-if="showButton" style="width:40px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>{{ item.title }}</td>
                        <td>
                            <v-progress-linear :value="item.percent" color="success"></v-progress-linear>
                            {{ item.percent | percent }}% ({{ item.progress }}/{{ item.noOfAssessors }})
                        </td>
                        <td v-if="showButton">
                            <v-btn @click="$emit('row-click', item)">รายละเอียด</v-btn>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>ค่าเฉลี่ย</th>
                        <th>
                            <v-progress-linear :value="totalPercent" color="success"></v-progress-linear>
                            {{ totalPercent | percent }}%
                        </th>
                        <th v-if="showButton"></th>
                    </tr>
                </tfoot>
            </v-simple-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "AssessmentProgressTable",

    props: ['items', 'title', 'showButton','loading'],

    computed: {
        totalPercent() {
            if (this.items.length) {
                let sum = 0;

                for (let i = 0; i < this.items.length; i++) {
                    sum += this.items[i].percent
                }

                return sum / this.items.length
            }

            return 0
        }
    },
}
</script>